import {
  Box,
  Flex,
  Grid,
  GridItem,
  Heading,
  Image,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";
import Steps from "../components/custom/Steps";
import Stats from "../components/custom/Stats";
import ChooseGrid from "../components/custom/ChooseGrid";
import TestimonialSwiper from "../components/custom/TestimonialSwiper";
import RichText from "../components/custom/RichText";
import { useColorModeValue } from "../components/ui/color-mode";
import { Helmet } from "react-helmet-async";

const AboutScreen = () => {
  const secondBg = useColorModeValue("#b8fff7", "#090110");
  const textColor = useColorModeValue("gray.600", "gray.500");

  return (
    <>
      {/* Helmet */}
      <Helmet>
        <title>About Us - 360fintax</title>
        <meta
          name="description"
          content="Learn about 360fintax, our mission to simplify tax processes, and how we provide expert financial services tailored to your needs."
        />
        <link
          rel="canonical"
          href="https://tax-services-web.vercel.app/about"
        />
      </Helmet>

      {/* Banner */}
      <Box bgColor={secondBg} py="20" px="10">
        <Flex
          direction={{ base: "column-reverse", md: "row" }}
          alignItems="center"
          gap={{ base: "10", lg: "32" }}
        >
          <Image
            src="../assets/about.png"
            h={{ base: "250px", md: "250px", lg: "330px" }}
            w={{ base: "350px", md: "350px", lg: "437px" }}
            loading="eager"
          />
          <Stack textAlign={{ base: "center", md: "left" }}>
            <Text fontSize="xl" color="#008080" fontWeight="semibold">
              Welcome to 360fintax
            </Text>
            <Text
              fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}
              fontWeight="semibold"
            >
              Your Shortcut to Stress-Free Tax Solutions
            </Text>
          </Stack>
        </Flex>
      </Box>

      {/* About */}
      <Grid
        templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }}
        px={{ base: "5", md: "10", lg: "20" }}
        py={{ base: "10", md: "10" }}
        gap={{ base: "10", md: "30" }}
        justifyItems="center"
        alignItems="center"
        data-aos="fade-up"
      >
        <GridItem>
          <Heading as="h1" size="2xl" mb="5">
            Welcome to 360fintax, where ancient wisdom meets modern expertise!
          </Heading>
          <Text fontSize="md" color={textColor}>
            Did you know that the practice of taxation dates back to ancient
            times? From the majestic courts of Indian kings who levied taxes to
            build grand temples and fortresses, to the intricate tax systems of
            the Mauryan Empire, taxation has always been a cornerstone of
            civilization. Just as our ancestors relied on skilled advisors to
            navigate the complexities of their tax obligations, today, you can
            rely on us. <br /> <br /> At 360fintax, we blend the rich heritage
            of tax practices with cutting-edge solutions to offer you
            unparalleled tax consulting services. Our team of seasoned
            professionals is dedicated to helping you manage your taxes
            efficiently, ensuring compliance while maximizing your savings.
            <br /> <br /> We understand that taxes can be daunting, but with our
            expertise, you can rest easy. Whether you're an individual, a small
            business, or a large corporation, we tailor our services to meet
            your unique needs. From tax planning and filing to advisory and
            dispute resolution, we are your trusted partners in every step of
            the way.
            <br /> <br />
            Join us on this journey through the annals of history and into the
            future of tax consulting. Let 360fintax be your guide in mastering
            the art of taxation..
          </Text>
        </GridItem>
        <GridItem>
          <Image
            src="../assets/about1.jpg"
            boxSize={{ base: "300px", md: "500px" }}
            // h={{ base: "300px", md: "550px" }}
            borderRadius="3xl"
            loading="eager"
            data-aos="zoom-in"
          />
        </GridItem>
      </Grid>

      {/* Stats */}
      <Stats />

      {/* Why Choose Us */}
      <Stack my={10} px={{ base: "5", md: "0" }} gap={10} data-aos="fade-up">
        {/* <Stack textAlign="center" pb={10}>
          <Text fontSize={{ base: "2xl", md: "4xl" }} fontWeight="bold">
            What sets us{" "}
            <Text as="span" color="#008080">
              apart?
            </Text>
          </Text>
          <Text
            fontSize={{ base: "md", md: "xl" }}
            fontWeight="600"
            color="gray.600"
          >
            We Handle the Details, So You Can Focus on What Matters Most.
          </Text>
        </Stack> */}
        <RichText
          title="What sets us apart?"
          colorText="apart?"
          description="We Handle the Details, So You Can Focus on What Matters Most."
        />
        <ChooseGrid showImage={false} />
      </Stack>

      {/* Testmonials */}
      <Stack
        data-aos="fade-up"
        textAlign="center"
        gap="10"
        py={{ base: "10", md: "10", lg: "20" }}
        alignItems="center"
      >
        <RichText
          title="Trusted by Clients,Proven Results"
          colorText="Proven Results"
          description="Discover how we've helped individuals and businesses stay compliant and stress-free, year after year."
          w={{ base: "xs", md: "3xl" }}
        />

        <TestimonialSwiper />
      </Stack>
    </>
  );
};

export default AboutScreen;
